import instance from './instance';

export default class Klickart {
  constructor(config = {}) {
    this.path = config.path;
    this.axios = instance();
  }

  post(resource = '', data, config = {}) {
    return this.axios.post(`${this.path}/${resource}`, data, { ...config });
  }

  get(resource = '', config = {}) {
    return this.axios.get(`${this.path}/${resource}`, { ...config });
  }
}



// WEBPACK FOOTER //
// ./src/services/request/klickart/index.js